import PropTypes from "prop-types"
import styles from "../../index.module.css"

const AvatarPlaceholder = ({ name = "" }) => {
  const initials = (name || "")
    .split(" ")
    .map((word) => word[0])
    .join("")
    .slice(0, 2)
    .toUpperCase()
  return <div className={styles.avatarPlaceholder}>{initials}</div>
}

AvatarPlaceholder.propTypes = { name: PropTypes.string }

export default AvatarPlaceholder
